import { gql } from '../../__generated__/gql'

export const COMMUNITY_PROFILE_QUERY = gql(`
  query communityProfile($userId: Int!) {
    communityProfile(userId: $userId) {
      id
      firstName
      lastName
      email
      picture
      roles
      communityProfile {
        ...communityProfileFields
      }
    }
  }
`)
